import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PlaceholderPage = ({ title, subtitle }) => {
  return (
    <main className="pt-24 pb-20 min-h-screen flex items-center">
      <div className="max-w-3xl mx-auto px-6 md:px-8 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6">
          <p className="text-sm uppercase tracking-[0.25em] text-[var(--accent-violet-light)] font-medium">Coming Soon</p>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white italic">{title}</h1>
          <p className="text-[var(--text-secondary)] text-lg">{subtitle}</p>
          <div className="pt-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[var(--accent-violet-light)] hover:text-white transition-colors font-medium"
            >
              <ArrowRight className="w-4 h-4 rotate-180" />
              Back to Home
            </Link>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default PlaceholderPage;
